"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIgnoredAlerts = exports.getAcceptedAlerts = exports.getRecommendedAlerts = exports.unescapeAlerts = exports.mapDataDistributionData = exports.mapInputProfileData = exports.getModelMetadata = exports.getModelMetricType = void 0;
var Localize_1 = require("../../gen-src/Localize");
var Analyses_1 = require("../components/model-results/type/Analyses");
var DateUtils_1 = require("./DateUtils");
var Utils_1 = require("./Utils");
var DATE_FIELD_DELIMITER = '~~~';
var EMPTY_PLACEHOLDER = '-';
var getModelMetricType = function (modelMetrics) {
    var _a;
    var type = (_a = modelMetrics === null || modelMetrics === void 0 ? void 0 : modelMetrics.validation) === null || _a === void 0 ? void 0 : _a.type;
    if (!type) {
        return EMPTY_PLACEHOLDER;
    }
    if ((0, Utils_1.isBinomialModel)(type)) {
        return Utils_1.ModelType.Binomial;
    }
    else if ((0, Utils_1.isRegressionModel)(type)) {
        return Utils_1.ModelType.Regression;
    }
    return EMPTY_PLACEHOLDER;
};
exports.getModelMetricType = getModelMetricType;
var getModelMetadata = function (story, modelMetrics) {
    var _a, _b, _c, _d;
    if (!story || !modelMetrics) {
        return {
            name: EMPTY_PLACEHOLDER,
            goal: EMPTY_PLACEHOLDER,
            outcomePrediction: EMPTY_PLACEHOLDER,
            createdAt: EMPTY_PLACEHOLDER,
            createdBy: EMPTY_PLACEHOLDER,
            lastModifiedAt: EMPTY_PLACEHOLDER,
            lastModifiedBy: EMPTY_PLACEHOLDER,
            type: EMPTY_PLACEHOLDER,
            algorithm: EMPTY_PLACEHOLDER,
        };
    }
    var modelOutcome = story.outcome;
    var outcomePrediction = EMPTY_PLACEHOLDER;
    if ((modelOutcome === null || modelOutcome === void 0 ? void 0 : modelOutcome.type) === Analyses_1.OutcomeType.Text) {
        outcomePrediction = Localize_1.Messages.valueAsExpression({ value: modelOutcome.name, as: modelOutcome.successValue });
    }
    else if ((modelOutcome === null || modelOutcome === void 0 ? void 0 : modelOutcome.type) === Analyses_1.OutcomeType.Number) {
        outcomePrediction = modelOutcome.name;
    }
    return {
        name: story.label,
        goal: modelOutcome.goal,
        outcomePrediction: outcomePrediction,
        createdAt: (0, DateUtils_1.formatDateTime)(story.createdDate),
        createdBy: story.createdBy.name,
        lastModifiedAt: (0, DateUtils_1.formatDateTime)(story.lastModifiedDate),
        lastModifiedBy: (_a = story.lastModifiedBy.name) !== null && _a !== void 0 ? _a : EMPTY_PLACEHOLDER,
        type: (0, exports.getModelMetricType)(modelMetrics),
        algorithm: (_d = (_c = (_b = story.setup) === null || _b === void 0 ? void 0 : _b.modelConfiguration) === null || _c === void 0 ? void 0 : _c.modelAlgType) !== null && _d !== void 0 ? _d : EMPTY_PLACEHOLDER,
    };
};
exports.getModelMetadata = getModelMetadata;
var mapInputProfileData = function (data) {
    return ((data === null || data === void 0 ? void 0 : data.fields.map(function (n) {
        return {
            name: n.name,
            correlation: n.associationToOutcome.value,
        };
    })) || []);
};
exports.mapInputProfileData = mapInputProfileData;
var _mapTextFieldToOutcomeDistribution = function (waveRecords, outcomeName) {
    return waveRecords.map(function (n) {
        return {
            name: n[outcomeName],
            count: Number(n.count),
        };
    });
};
var _mapDateFieldToOutcomeDistribution = function (waveRecords, outcomeField) {
    var interval = outcomeField.interval;
    var outcomeName = outcomeField.name;
    var keyIndicator = [];
    switch (interval === null || interval === void 0 ? void 0 : interval.toLowerCase()) {
        case 'year':
            keyIndicator.push("".concat(outcomeName, "_Year"));
            break;
        case 'month':
            keyIndicator.push("".concat(outcomeName, "_Month"));
            keyIndicator.push("".concat(outcomeName, "_Year"));
            break;
        case 'day':
            keyIndicator.push("".concat(outcomeName, "_Day"));
            keyIndicator.push("".concat(outcomeName, "_Month"));
            keyIndicator.push("".concat(outcomeName, "_Year"));
            break;
    }
    if (!keyIndicator.length) {
        return null;
    }
    var key = keyIndicator.join(DATE_FIELD_DELIMITER);
    return waveRecords.map(function (n) {
        return {
            name: n[key].replace(new RegExp(DATE_FIELD_DELIMITER, 'g'), '/'),
            count: Number(n.count),
        };
    });
};
var _mapNumericFieldToOutcomeDistribution = function (waveRecords, outcomeField) {
    var min = outcomeField.min;
    var max = outcomeField.max;
    var numBuckets = outcomeField.numBuckets;
    var delta = (max - min) / numBuckets;
    var result = [];
    var _loop_1 = function (i) {
        var bin = waveRecords.find(function (n) { return Number(n['bin']) === i; });
        if (bin) {
            result.push({
                name: (min + Number(bin['bin']) * delta).toFixed(1),
                count: Number(bin['count']),
            });
        }
        else {
            result.push({
                name: (min + i * delta).toFixed(1),
                count: 0,
            });
        }
    };
    for (var i = 0; i < numBuckets; i++) {
        _loop_1(i);
    }
    return result;
};
var mapDataDistributionData = function (story, waveQueryResult) {
    var _a, _b;
    var outcomeName = (_a = story.outcome) === null || _a === void 0 ? void 0 : _a.name;
    var setupFields = (_b = story.setup) === null || _b === void 0 ? void 0 : _b.fields;
    var waveRecords = waveQueryResult === null || waveQueryResult === void 0 ? void 0 : waveQueryResult.records;
    if (!outcomeName || !setupFields || !waveRecords) {
        return null;
    }
    var outcomeField = setupFields.find(function (n) { return n.name === outcomeName; });
    if ((outcomeField === null || outcomeField === void 0 ? void 0 : outcomeField.type) === Analyses_1.FieldColumnType.Text) {
        return _mapTextFieldToOutcomeDistribution(waveRecords, outcomeName);
    }
    else if ((outcomeField === null || outcomeField === void 0 ? void 0 : outcomeField.type) === Analyses_1.FieldColumnType.Date) {
        return _mapDateFieldToOutcomeDistribution(waveRecords, outcomeField);
    }
    else if ((outcomeField === null || outcomeField === void 0 ? void 0 : outcomeField.type) === Analyses_1.FieldColumnType.Number) {
        return _mapNumericFieldToOutcomeDistribution(waveRecords, outcomeField);
    }
    return null;
};
exports.mapDataDistributionData = mapDataDistributionData;
var _unescape = function (text) {
    var returnText = text;
    returnText = returnText.replace(/&nbsp;/gi, ' ');
    returnText = returnText.replace(/&amp;/gi, '&');
    returnText = returnText.replace(/&quot;/gi, "\"");
    returnText = returnText.replace(/&lt;/gi, '<');
    returnText = returnText.replace(/&gt;/gi, '>');
    return returnText;
};
var unescapeAlerts = function (alerts) {
    alerts.forEach(function (alert) {
        alert.subject = _unescape(alert.subject);
    });
    return alerts;
};
exports.unescapeAlerts = unescapeAlerts;
var getRecommendedAlerts = function (alerts) {
    return (alerts || []).filter(function (n) { return !n.accepted && !n.dismissed && n.applicable; });
};
exports.getRecommendedAlerts = getRecommendedAlerts;
var getAcceptedAlerts = function (alerts) {
    return (alerts || []).filter(function (n) { return n.accepted && !n.dismissed && n.applicable; });
};
exports.getAcceptedAlerts = getAcceptedAlerts;
var getIgnoredAlerts = function (alerts) {
    return (alerts || []).filter(function (n) { return !n.accepted && n.dismissed && n.applicable; });
};
exports.getIgnoredAlerts = getIgnoredAlerts;
//# sourceMappingURL=MapperUtils.js.map